import React from 'react';
import { Box } from '@mui/material';
import AgentServicesTable from '../AgentServicesTable';
import PanelCard from './PanelCard';

function CostsPanel() {
  return (
    <Box>
      <PanelCard title="Leistungen & Kosten" subtitle="Zugewiesene Leistungen mit Preisen">
        <AgentServicesTable />
      </PanelCard>
    </Box>
  );
}

export default CostsPanel;
